function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useEffect, useState } from 'react';
import Dropdown from '@rd-web-markets/shared/dist/util/Dropdown';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import IsNotSaved from '../IsNotSaved';
import deminimisRegulationService from '../../../services/company/deminimis_regulation.service';
import DeminimisSubsidy from './DeminimisSubsidy';
import { useTranslation } from 'react-i18next';
const DEMINIMIES_VER_OPTIONS = [{
  key: 'yes',
  value: 'true',
  text: 'yes'
}, {
  key: 'no',
  value: 'false',
  text: 'no'
}];
const DeminimisRegulation = _ref => {
  let {
    elster
  } = _ref;
  const {
    t
  } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [isNotSaved, setIsNotSaved] = useState(false);
  const {
    regulation,
    setRegulation,
    updateRegulation
  } = deminimisRegulationService.useCrud(elster === null || elster === void 0 ? void 0 : elster.id, setLoading);
  const isVersion8 = (elster === null || elster === void 0 ? void 0 : elster.version_number) === 'version_8';
  const titleKey = isVersion8 ? 'tk_deminimis_section3_3_subtitle_v8' : 'tk_deminimis_section3_3_subtitle';
  const saveData = useCallback(async body => {
    await updateRegulation({
      deminimis_regulation: {
        deminimies_ver: body.deminimies_ver
      }
    });
    setIsNotSaved(false);
  }, [updateRegulation]);
  if (loading && regulation == null) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "mb-3"
  }, t(titleKey)), /*#__PURE__*/React.createElement(Dropdown, {
    name: "deminimies_ver",
    fieldName: "deminimies_ver",
    label: 'dmver_1_1',
    value: regulation === null || regulation === void 0 ? void 0 : regulation.deminimies_ver,
    onChange: val => {
      setRegulation(prev => _objectSpread(_objectSpread({}, prev), {}, {
        deminimies_ver: val
      }));
      setIsNotSaved(true);
    },
    options: DEMINIMIES_VER_OPTIONS,
    dataTestId: "deminimis_regulation_deminimies_ver",
    labelColSpan: 6,
    showNullOption: true
  }), regulation != null && /*#__PURE__*/React.createElement(DeminimisSubsidy, {
    elsterId: elster.id,
    regulation: regulation,
    setRegulation: setRegulation,
    setLoading: setLoading
  }), /*#__PURE__*/React.createElement(IsNotSaved, {
    isNotSaved: isNotSaved,
    save: saveData,
    paramsForUpdate: [regulation || {
      deminimis_regulation: {
        deminimies_ver: null
      }
    }]
  }));
};
export default DeminimisRegulation;